/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'missing-cert-issuer-icon';
const prefix = `${moduleName}.${componentName}`;

export const certificateMissingTooltipLabel = `${prefix}.certificateMissingTooltipLabel`;

export const ENGLISH = {
    [certificateMissingTooltipLabel]: 'Issuer Certificate Missing',
};
